import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';

import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import StarRating from '../../StarRating';
import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import TableAction from '../../CommonTable/TableAction';
import Link from '../../../components/Link';
import Loader from '../../Loader/Loader';

import { deleteAdminReview } from '../../../actions/siteadmin/AdminReviews/deleteAdminReview';
import { withQuery } from '../../../hoc/withGraphql';
import { demoRestriction } from '../../../helpers/DemoRestriction/demoRestriction';


import reviewsManagement from './reviewsManagement.graphql';

import { getDynamicTitle } from '../../../helpers/GetDynamicItemName/getDynamicName';
import cs from '../../../components/commonStyle.css';
import s from './AdminReviewsManagement.css';
import messages from '../../../locale/jsonMessages';
class AdminReviewsManagement extends React.Component {

  static propTypes = {
    data: PropTypes.array,
    editUser: PropTypes.any,
    deleteAdminReview: PropTypes.any,
    title: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      currentPage: 1,
      searchList: '',
      typing: false,
      typingTimeout: 0
    }
  }

  paginationData = (currentPage) => {
    const { reviewsManagement: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage })
    refetch(variables);
  }

  handleClick = (searchList) => {
    const { reviewsManagement: { refetch }, setStateVariable } = this.props;
    const { currentPage } = this.state;
    let variables = {
      currentPage: 1,
      searchList: searchList
    };
    this.setState(variables)
    refetch(variables);
  }

  handleSearchChange = (e) => {
    const self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleClick(self.state.searchList);
      }, 450)
    });
  }

  deleteReview = async (id) => {
    const { deleteAdminReview, setStateVariable, currentPage, demoRestriction } = this.props;
    const { reviewsManagement: { refetch, reviewsManagement } } = this.props;
    let variables = { currentPage: currentPage > 1 && reviewsManagement?.reviewsData?.length == 1 ? currentPage - 1 : currentPage };
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    const response = await deleteAdminReview(id);
    if (response?.status == 200) {
      await setStateVariable(variables);
      await refetch(variables);
    }
  }

  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.carID) },
      { data: formatMessage(messages.carNameLabel) },
      { data: formatMessage(messages.reviewContentLabel) },
      { data: formatMessage(messages.ratingReviewLabel) },
    ]
  };

  tbody = (props) => {
    const { reviewsManagement: { reviewsManagement }, locale, dynamicTitle } = props;

    return reviewsManagement?.reviewsData.map((value, key) => {
      let dynamicListTitle = getDynamicTitle({ data: dynamicTitle, locale, id: value?.listId });
      return {
        id: key,
        data: [
          { data: value.listId },
          {
            data: <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween)}>
              <Link to={"/cars/" + value.listId} className={cs.siteLinkColor}>
                {dynamicListTitle || (value.listData ? value.listData.title : 'Car is missing')}
              </Link>
              <TableAction
                showDelete={true}
                onClickDelete={() => this.deleteReview(value.id)}
                showEdit={true}
                editLink={"/siteadmin/edit-review/" + value.id}
              />
            </div>
          },
          { data: value.reviewContent },
          {
            data: <StarRating value={value.rating} name={'review'} starCount={5} />
          },
        ]
      }
    })
  }

  render() {
    const { currentPage } = this.state;
    const { reviewsManagement: { loading, reviewsManagement } } = this.props;
    const { formatMessage } = this.props.intl;

    if (loading) {
      return <Loader type={"text"} />
    }
    return (
      <div>
        <CommonTable
          thead={this.thead}
          tbody={() => this.tbody(this.props)}
          title={formatMessage(messages.manageAdminReviews)}
          isSearch
          onSearch={this.handleSearchChange}
        />
        {
          !loading && reviewsManagement?.reviewsData?.length > 0
          && <div>
            <CustomPagination
              total={reviewsManagement.count}
              currentPage={currentPage}
              defaultCurrent={1}
              defaultPageSize={10}
              change={this.paginationData}
              paginationLabel={formatMessage(messages.reviews)}
            />
          </div>
        }
      </div>
    );
  }

}

const mapState = (state) => ({
  locale: state?.intl?.locale,
  dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle
});

const mapDispatch = {
  deleteAdminReview,
  demoRestriction
};

export default compose(injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withQuery(reviewsManagement, {
    name: 'reviewsManagement',
    options: (props) => ({
      variables: {
        currentPage: props.currentPage,
        searchList: props.searchList,
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(AdminReviewsManagement);